<template>
  <div class="sky-hc-left-full-nav">
    <left-nav :data="navList" :hasSearch="false"></left-nav>
  </div>
</template>
<script>
import LeftNav from './leftNav'

import { getInsidePageSetting } from '@/api/help'

export default {
  name: 'LeftFullNav',
  components: {
    LeftNav
  },
  data() {
    return {
      navList: []
    }
  },
  created() {
    this.handleGetCongfig()
  },
  methods: {
    handleGetCongfig() {
      getInsidePageSetting().then(response => {
        const content = response.data.content
        if (content && content.quickLinks) {
          this.navList = content.quickLinks
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-left-full-nav) {
  width: 252px;
  min-height: calc(100vh - 60px);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  padding-top: 75px;
  box-sizing: border-box;
  padding-left: 20px;
}
</style>
